export const getFileExtensionFromDataUrl = (dataUrl: string): string => {
  const match = dataUrl.match(/data:image\/([a-zA-Z]+);base64,/);
  if (match && match[1]) {
    return match[1];
  }

  return 'jpg';
};

export const getMimeTypeFromDataUrl = (dataUrl: string): string => {
  const match = dataUrl.match(/data:([^;]+);base64,/);
  if (match && match[1]) {
    return match[1];
  }

  return 'image/jpeg';
};

export const isValidDataUrl = (dataUrl: string): boolean => {
  return /^data:image\/[a-zA-Z]+;base64,/.test(dataUrl);
};

export const dataUrlToFile = (dataUrl: string, filename: string): File => {
  const mimeType = getMimeTypeFromDataUrl(dataUrl);
  const base64Data = dataUrl.split(',')[1];

  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
};
